import { elementExists } from '../utils';
import CartAwareProductForm from './cart-aware-product-form';
const InitCartAwareProductForms = function (hasCartDrawer) {
  const forms = document.querySelectorAll(($selector = '[sh-cart-aware-product-form]'));

  if (elementExists(forms)) {
    forms.forEach(form => {
      let data = form.dataset;

      if (typeof data.productId != 'undefined') {
        try {
          let product_data = JSON.parse(form.querySelector('.product-json').innerHTML);
          let current_variant = JSON.parse(form.querySelector('.current-variant-json').innerHTML);
          let item = new CartAwareProductForm(product_data, current_variant, form, hasCartDrawer);
          item.init();
        } catch (err) {
          console.log(err, 'error getting product-json');
        }
      }
    });
  }
};
export default InitCartAwareProductForms;
